import AllocationService from "./allocation/allocationService";
import AuthenService from "./authentication/authenService";
import BillingNoteService from "./document/BillingNote/billingNoteService";
import CreditNoteService from "./document/CreditNote/creditNoteService";
import CreditNoteExpenseService from "./document/CreditNoteExpense/creditNoteExpenseService";
import DebitNoteExpenseService from "./document/DebitNoteExpense/debitNoteExpenseService";
import CombinePaymentNoteService from "./document/combinePaymentNote/combinePaymentNoteService";
import ContactService from "./document/contact/contactService";
import CustomizeService from "./document/customize/customizeService";
import DailyJournalService from "./document/dailyJournal/dailyJournalService";
import DebitNoteService from "./document/debitNote/debitNoteService";
import DepositService from "./document/deposit/depositService";
import DocumentService from "./document/documentService";
import ExecutiveSummaryService from "./document/executiveSummary/executiveSummaryService";
import ExpenseService from "./document/expense/expenseService";
import GoodsReceiptsService from "./document/goodsReceipt/goodsReceiptService";
import InvoiceService from "./document/invoice/invoiceService";
import InvoiceReceiptService from "./document/invoiceReceipt/invoiceReceiptService";
import PndService from "./document/pnd/pndService";
import PP30Service from "./document/pp30/pp30Service";
import PurchaseOrderService from "./document/purchaseOrder/purchaseOrderService";
import PurchaseRequisitionService from "./document/purchaseRequisition/purchaseRequisitionService";
import QuotationService from "./document/quotation/quotationService";
import ReceiptService from "./document/receipt/receiptService";
import TaxInvoiceService from "./document/taxInvoice/taxInvoiceService";
import WitholdingTaxService from "./document/witholdingTax/WitholdingTaxService";
import GeneratePdfService from "./generatePdf/generatePdf";
import MerchantService from "./merchant/merchantService";
import PaymentService from "./payment/paymentService";

export default {
  AuthenService,
  MerchantService,
  QuotationService,
  DocumentService,
  InvoiceService,
  ReceiptService,
  PurchaseOrderService,
  ExpenseService,
  TaxInvoiceService,
  GeneratePdfService,
  DailyJournalService,
  BillingNoteService,
  CombinePaymentNoteService,
  WitholdingTaxService,
  PP30Service,
  PndService,
  CreditNoteService,
  CreditNoteExpenseService,
  ContactService,
  DebitNoteService,
  DebitNoteExpenseService,
  PaymentService,
  ExecutiveSummaryService,
  CustomizeService,
  DepositService,
  GoodsReceiptsService,
  InvoiceReceiptService,
  AllocationService,
  PurchaseRequisitionService,
};
